import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Message from 'components/atoms/Message';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface SearchChangedModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;

    //used in unused function handleChange
    data: any;

    actions: ActionsType | undefined;
}

interface SearchChangedModelState {
    //used in unused function handleChange
    errors: object;

    //used in unused function handleChange
    data: any | null;
}

class SearchChangedModel extends Component<SearchChangedModelProps, SearchChangedModelState> {
    constructor(props: SearchChangedModelProps) {
        super(props);
        this.state = {
            data: null,
            errors: {},
        };
    }

    //unused function
    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Search changed')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <Message className="mt-4" type="error">
                        {translate('Existing analysis results to previous search. Update analysis?')}
                    </Message>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-1 font-bold border border-gray-200"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Ignore')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Update')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SearchChangedModel);
